// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w_yMPl5{position:relative;margin-bottom:1rem;padding-left:2.2rem;font-size:14px;line-height:1.5;color:#576875}.w_yMPl5>span{position:absolute;top:0;left:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxItem": `w_yMPl5`
};
export default ___CSS_LOADER_EXPORT___;
